import { root } from 'elc-universal-utils';
import { BrowserComponentRenderer } from './BrowserComponentRenderer';
import { ViewDataPreloader } from './preloader/ViewDataPreloader';
const packageJson = require('../package.json');

root.versions = root.versions || {};
root.versions[packageJson.name] = packageJson.version;

if (root && !root.ComponentRenderer) {
    root.ComponentRenderer = new BrowserComponentRenderer();
    const preloader = new ViewDataPreloader();
    root.registerConfigFieldsToPreload =
        root.registerConfigFieldsToPreload || preloader.registerConfigFieldsToPreload;
    root.getPreloadedConfigs = root.getPreloadedConfigs || preloader.getPreloadedConfigs;
    root.registerTranslationFieldsToPreload =
        root.registerTranslationFieldsToPreload || preloader.registerTranslationFieldsToPreload;
    root.getPreloadedTranslations =
        root.getPreloadedTranslations || preloader.getPreloadedTranslations;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (root.ComponentRenderer as any).setDataPreloader(preloader);
}

export { BrowserComponentRenderer };
